module.exports = __webpack_public_path__ + "static/beneficios-min-83850c77b0f0e75bbac3146679511cc6.jpg";